import { render } from "./mainPostList.vue?vue&type=template&id=54f03257&scoped=true"
import script from "./mainPostList.vue?vue&type=script&lang=js"
export * from "./mainPostList.vue?vue&type=script&lang=js"

import "./mainPostList.vue?vue&type=style&index=0&id=54f03257&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-54f03257"

export default script